export const audioSolution = {
  MIC_ACCESS_REQUIRED: 'Microphone permissions are required!',
  DESCRIPTION: 'Description',
  GRANT_MIC_ACCESS: 'Please grant Microphone permission, then reload the page.',
  MEDIA_TYPE: 'audio/wav',
  MEDIA_DESCRIPTION: {
    audioBitsPerSecond: 128000,
  },
  WARNING_TEXT:
    ' Depending on your network, submission can take a while. Please submit before timer runs out.',
  AUDIO_UPLOAD_ERROR: 'audio upload error',
  REPLACE_AUDIO: 'Replace audio',
  CONTINUE: 'Continue to assessment',
  YES_I_UNDERSTAND: 'Yes,I Understand',
  ALREADY_UPLOADED_MESSAGE:
    'A audio is already uploaded. Do you want to replace the uploaded audio with the new audio?',
  RECORD_AGAIN_WARNING:
    'By clicking on “Record Again”, your current recording would be replaced.',
  ARE_YOU_SURE_TEXT: 'Are you sure you want to do that?',
  TIMEOUT_MESSAGE: 'Recording time is over!',
  UPLOAD_IN_PROGRESS_MESSAGE:
    'Uploading audio file. You may move onto the next question.',
  UPLOAD_TAKING_LONGER_MESSAGE:
    'Uploading is taking longer than expected. We recommend canceling and retrying.',
  UPLOADED_SUCCESSFULLY: 'Audio Uploaded Successfully',
  UPLOAD_COMPLETED: 'Upload Completed...',
  PERMISSION_DENIED: 'Permission denied',
  PERMISSION_DISMISSED: 'Permission dismissed',
  MOVE_AWAY_WARNING:
    'NOTE : Your current actions will be canceled. Would you like to continue?',
};

export const modalCases = {
  TIMEOUT: 'timeout',
  UPLOAD: 'upload',
  RECORD_AGAIN: 'recordAgain',
  MOVE_AWAY: 'moveAway',
};

export const audioFormats = ['audio/mp3'];

export const indexedDBError = {
  getItemErrorText: 'Unable to get audio from IndexedDB',
  setItemErrorText: 'Unable to save audio in IndexedDB',
  removeItemErrorText: 'Unable to remove audio from IndexedDB',
  dbDeleteErrorText: 'Unable to delete IndexedDB!',
};

export const EAudioRecordingStatus = {
  INITIATED: 'initiated',
  RECORDING: 'recording',
  STOPPED: 'stopped',
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  FAILED: 'failed',
  COMPLETED: 'completed',
};

export const AUDIO_DB = 'audioDB';
export const AUDIO_STORE = 'audioStore';

export const EAudioRecordingAction = {
  INITIATE: 'initiate',
  RECORD: 'record',
  STOP: 'stop',
  RERECORD: 're-record',
  UPLOAD: 'upload',
  SUBMIT: 'submit',
};

export const VOLUME_THRESHOLD = 140;
export const LOW_VOLUME_DURATION_THRESHOLD = 5000;
export const LOW_AUDIO_DETECTED_MESSAGE = 'Low/No audio - Please check mic';
export const NO_AUDIO_DETECTED_MESSAGE = 'No audio - Try again';

export const LOW_OR_NO_VOLUME_WARNING = 'low_volume_warning';
export const FINAL_AUDIO_WARNING = 'final_audio_volume_warning';

export const FINAL_LOW_NO_VOLUME_WARNING_SESSION_KEY = 'volumeFinalWarning';
